import { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { toggleTheme, setTheme } from '../store/slices/themeSlice'

export const useTheme = () => {
  const dispatch = useDispatch()
  const { isDarkTheme } = useSelector(state => state.theme)

  useEffect(() => {
    // Apply theme to body element
    if (isDarkTheme) {
      document.body.classList.remove('light-theme') // Remove light theme to show default dark theme
    } else {
      document.body.classList.add('light-theme') // Add light theme
    }

    // Save to localStorage
    localStorage.setItem('theme', isDarkTheme ? 'dark' : 'light')
  }, [isDarkTheme])

  useEffect(() => {
    // Load theme from localStorage on mount
    const savedTheme = localStorage.getItem('theme')
    if (savedTheme === 'light' && isDarkTheme) {
      dispatch(setTheme(false))
    } else if (savedTheme === 'dark' && !isDarkTheme) {
      dispatch(setTheme(true))
    }
  }, [dispatch, isDarkTheme])

  const handleToggleTheme = () => {
    dispatch(toggleTheme())
  }

  return {
    isDarkTheme,
    toggleTheme: handleToggleTheme
  }
}
